import React, { useState } from 'react';
import DockIcons from './DockIcons';

const Dock = ({ windows, onToggleWindow, onRestoreWindow, minimized, onTrashClick }) => {
  const [bouncingIcon, setBouncingIcon] = useState(null);
  
  // All possible apps/windows with their metadata
  // Ordered for Discovery Journey: Introduction → Work → Engagement
  const allApps = {
    about: { icon: DockIcons.about, label: 'About Me', color: '#00ff41', permanent: true },
    projects: { icon: DockIcons.projects, label: 'Projects', color: '#00ff41', permanent: true },
    terminal: { icon: DockIcons.terminal, label: 'Terminal', color: '#00ff41', permanent: true },
    filemanager: { icon: DockIcons.filemanager, label: 'Files', color: '#00ffaa', permanent: true },
    notes: { icon: DockIcons.notes, label: 'Notes', color: '#39ff14', permanent: true },
    cyberchef: { icon: DockIcons.cyberchef, label: 'SwissArmy', color: '#00ff41', permanent: true },
    taskmanager: { icon: DockIcons.taskmanager, label: 'Task Manager', color: '#00ffdd', permanent: true },
    root: { icon: DockIcons.root, label: 'Root Access', color: '#ff4444', permanent: true },
    contact: { icon: DockIcons.contact, label: 'Contact Me', color: '#00ff88', permanent: true }
  };

  // Filter to show: permanent apps + currently open windows
  const appsToShow = Object.entries(allApps)
    .filter(([key, app]) => app.permanent || windows[key])
    .map(([key, app]) => ({ key, ...app }));

  return (
    <div className="dock-container">
      <div className="dock">
        {appsToShow.map((app) => (
          <div
            key={app.key}
            className={`dock-icon ${windows[app.key] ? 'running' : ''} ${minimized[app.key] ? 'minimized' : ''} ${bouncingIcon === app.key ? 'bounce' : ''}`}
            onClick={() => {
              // Trigger bounce animation
              setBouncingIcon(app.key);
              setTimeout(() => setBouncingIcon(null), 600);
              
              if (minimized[app.key]) {
                onRestoreWindow(app.key);
              } else {
                onToggleWindow(app.key, !windows[app.key]);
              }
            }}
            title={app.label}
          >
            <div className="dock-icon-content" style={{ '--app-color': app.color }}>
              <div className="dock-icon-svg">{app.icon}</div>
              {windows[app.key] && (
                <div className="running-indicator">
                  <div className="indicator-dot"></div>
                </div>
              )}
            </div>
            <div className="dock-label">{app.label}</div>
          </div>
        ))}
        
        {/* Separator before utilities */}
        <div className="dock-separator"></div>
        
        {/* Resume Download Icon */}
        <div
          className={`dock-icon ${bouncingIcon === 'resume' ? 'bounce' : ''}`}
          onClick={() => {
            setBouncingIcon('resume');
            setTimeout(() => setBouncingIcon(null), 600);
            // Open resume window instead of downloading
            onToggleWindow('resume', !windows.resume);
          }}
          title="Resume"
        >
          <div className="dock-icon-content" style={{ '--app-color': '#9966ff' }}>
            <div className="dock-icon-svg">{DockIcons.resume}</div>
            {windows.resume && (
              <div className="running-indicator">
                <div className="indicator-dot"></div>
              </div>
            )}
          </div>
          <div className="dock-label">Resume</div>
        </div>
        
        {/* Trash Icon */}
        <div
          className={`dock-icon trash-icon ${bouncingIcon === 'trash' ? 'bounce' : ''}`}
          onClick={() => {
            setBouncingIcon('trash');
            setTimeout(() => setBouncingIcon(null), 600);
            onTrashClick();
          }}
          title="Trash"
        >
          <div className="dock-icon-content" style={{ '--app-color': '#ff4444' }}>
            <div className="dock-icon-svg">{DockIcons.trash}</div>
          </div>
          <div className="dock-label">Trash</div>
        </div>
      </div>
    </div>
  );
};

export default Dock;
